import { Component } from '@angular/core';


@Component({
  selector: 'app-crear',
  templateUrl: './crear.component.html',
  styleUrls: ['./crear.component.scss']
})
export class CrearComponent {

 
  public Origen = [
    { value: "1", label: "CARTAGENA", job: "Developer" },
    { value: "2", label: "VALLEDUPAR", job: "Developer" },
    { value: "3", label: "MEDELLIN", job: "Designer" },

  ];
  public origen: string;


  public Destino = [
    { value: "1", label: "CARTAGENA", job: "Developer" },
    { value: "2", label: "VALLEDUPAR", job: "Developer" },
    { value: "3", label: "MEDELLIN", job: "Designer" },

  ];
  public destino: string;
  


  

  ngOnInit(): void {}
}